import { Routes } from '@angular/router';
import { LoginComponent } from './authentication/login/login.component';
import { ForgotPasswordComponent } from './authentication/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './authentication/reset-password/reset-password.component';
import { OtpVarificationComponent } from './authentication/otp-varification/otp-varification.component';
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';
// import { OnboardingShellComponentComponent } from './after-login/pages/onboarding-shell-component/onboarding-shell-component.component';
// import { AmenitiesStepComponent } from './after-login/pages/onboarding-shell-component/steps/amenities-step/amenities-step.component';
// import { FacilitiesStepComponent } from './after-login/pages/onboarding-shell-component/steps/facilities-step/facilities-step.component';
// import { PropertyTypeStepComponent } from './after-login/pages/onboarding-shell-component/steps/property-type-step/property-type-step.component';
// import { TowerStepComponent } from './after-login/pages/onboarding-shell-component/steps/tower-step/tower-step.component';
// import { TaxTypeStepComponent } from './after-login/pages/onboarding-shell-component/steps/tax-type-step/tax-type-step.component';
// import { PropertyStepComponent } from './after-login/pages/onboarding-shell-component/steps/property-step/property-step.component';
// import { FloorStepComponent } from './after-login/pages/onboarding-shell-component/steps/floor-step/floor-step.component';
// import { DepartmentStepComponent } from './after-login/pages/onboarding-shell-component/steps/department-step/department-step.component';
// import { RoleStepComponent } from './after-login/pages/onboarding-shell-component/steps/role-step/role-step.component';
// import { FinalStepComponent } from './after-login/pages/onboarding-shell-component/steps/final-step/final-step.component';
// import { RoomTypeStepComponent } from './after-login/pages/onboarding-shell-component/steps/room-type-step/room-type-step.component';
// import { ShiftStepComponent } from './after-login/pages/onboarding-shell-component/steps/shift-step/shift-step.component';
// import { RoomViewStepComponent } from './after-login/pages/onboarding-shell-component/steps/room-view-step/room-view-step.component';
// import { TaskManagerStepComponent } from './after-login/pages/onboarding-shell-component/steps/task-manager-step/task-manager-step.component';
// import { PriorityTaskComponent } from './after-login/pages/settings/drawers/hotel-settings/priority-task/priority-task.component';
// import { PriorityTaskStepComponent } from './after-login/pages/onboarding-shell-component/steps/priority-task-step/priority-task-step.component';
import { onboardingGuard } from './guards/onboarding.guard';
import { DocumentUploadedComponent } from './after-login/components/profile-verify/document-uploaded/document-uploaded.component';
import { ProfileVerifyComponent } from './after-login/components/profile-verify/profile-verify.component';
import { ProfileGuard } from './guards/profile-gurd.guard';
import { PropertyChooseComponent } from './authentication/property-choose/property-choose.component';
import { AccessPendingComponent } from './authentication/access-pending/access-pending.component';


export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [LoginGuard],
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [LoginGuard],
  },
  {
    path: 'otp-verification',
    component: OtpVarificationComponent,
    canActivate: [LoginGuard],
  },
  { path: 'upload-documents', component: ProfileVerifyComponent },
  { path: 're-upload-documents', component: DocumentUploadedComponent },
  { path: 'property-choose', component: PropertyChooseComponent },
  {
    path: 'onboarding',
    canActivate: [ProfileGuard],
    // component: OnboardingShellComponentComponent,
    loadComponent: () =>
      import('./after-login/pages/onboarding-shell-component/onboarding-shell-component.component')
        .then(m => m.OnboardingShellComponentComponent),
    children: [
      { path: '', redirectTo: 'amenities', pathMatch: 'full' },
      {
        path: 'amenities',
        loadComponent: () =>
          import('./after-login/pages/onboarding-shell-component/steps/amenities-step/amenities-step.component')
            .then(m => m.AmenitiesStepComponent)
      },
      {
        path: 'facilities',
        loadComponent: () =>
          import('./after-login/pages/onboarding-shell-component/steps/facilities-step/facilities-step.component')
            .then(m => m.FacilitiesStepComponent),
        canActivate: [onboardingGuard],
      },
      {
        path: 'property-type',
        loadComponent: () =>
          import('./after-login/pages/onboarding-shell-component/steps/property-type-step/property-type-step.component')
            .then(m => m.PropertyTypeStepComponent),
        canActivate: [onboardingGuard],
      },
      {
        path: 'tower',
        loadComponent: () =>
          import('./after-login/pages/onboarding-shell-component/steps/tower-step/tower-step.component')
            .then(m => m.TowerStepComponent),
        canActivate: [onboardingGuard],
      },
      {
        path: 'floor',
        loadComponent: () =>
          import('./after-login/pages/onboarding-shell-component/steps/floor-step/floor-step.component')
            .then(m => m.FloorStepComponent),
        canActivate: [onboardingGuard],
      },
      {
        path: 'roomtype',
        // component: RoomTypeStepComponent,
        loadComponent: () =>
          import('./after-login/pages/onboarding-shell-component/steps/room-type-step/room-type-step.component')
            .then(m => m.RoomTypeStepComponent),
        canActivate: [onboardingGuard],
      },
      {
        path: 'shift',
        loadComponent: () =>
          import('./after-login/pages/onboarding-shell-component/steps/shift-step/shift-step.component')
            .then(m => m.ShiftStepComponent),
        canActivate: [onboardingGuard],
      },
      {
        path: 'roomview',
        loadComponent: () =>
          import('./after-login/pages/onboarding-shell-component/steps/room-view-step/room-view-step.component')
            .then(m => m.RoomViewStepComponent),
        canActivate: [onboardingGuard],
      },
      {
        path: 'task',
        loadComponent: () =>
          import('./after-login/pages/onboarding-shell-component/steps/task-manager-step/task-manager-step.component')
            .then(m => m.TaskManagerStepComponent),
        canActivate: [onboardingGuard],
      },
      {
        path: 'prioritytask',
        loadComponent: () =>
          import('./after-login/pages/onboarding-shell-component/steps/priority-task-step/priority-task-step.component')
            .then(m => m.PriorityTaskStepComponent),
        canActivate: [onboardingGuard],
      },
      {
        path: 'taxtype',
        loadComponent: () =>
          import('./after-login/pages/onboarding-shell-component/steps/tax-type-step/tax-type-step.component')
            .then(m => m.TaxTypeStepComponent),
        canActivate: [onboardingGuard],
      },
      {
        path: 'property',
        loadComponent: () =>
          import('./after-login/pages/onboarding-shell-component/steps/property-step/property-step.component')
            .then(m => m.PropertyStepComponent),
        canActivate: [onboardingGuard],
      },
      {
        path: 'department',
        loadComponent: () =>
          import('./after-login/pages/onboarding-shell-component/steps/department-step/department-step.component')
            .then(m => m.DepartmentStepComponent),
        canActivate: [onboardingGuard],
      },
      {
        path: 'role',
        loadComponent: () =>
          import('./after-login/pages/onboarding-shell-component/steps/role-step/role-step.component')
            .then(m => m.RoleStepComponent),
        canActivate: [onboardingGuard],
      },
      {
        path: 'finish',
        loadComponent: () =>
          import('./after-login/pages/onboarding-shell-component/steps/final-step/final-step.component')
            .then(m => m.FinalStepComponent),
        canActivate: [onboardingGuard],
      },
    ],
  },
  {
    path: 'access-pending',
    component: AccessPendingComponent
  },
  {
    path: 'syncinns-pms',
    loadChildren: () =>
      import('./after-login/after-loging.routes').then(
        (m) => m.afterLoginRoutes
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'channel-manager',
    loadChildren: () =>
      import('./after-login/routes/channel-manager/channel-manager.routes').then(
        (m) => m.channelManagerRoutes
      ),
    canActivate: [AuthGuard],
  },
];
